import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../../constants';

@Injectable({ providedIn: 'root' })
export class PayrollService {
  private api = `${baseUrl}Payroll`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
  }

  getConfigs(): Observable<any[]> {
    return this.http.get<any[]>(`${this.api}/configs`, this.headers);
  }

  saveConfig(payload: any): Observable<any> {
    return this.http.put<any>(`${this.api}/configs`, payload, this.headers);
  }

  generateSlip(payload: any): Observable<any> {
    return this.http.post<any>(`${this.api}/slips/generate`, payload, this.headers);
  }

  getSlips(filters?: { staffId?: number; from?: string; to?: string }): Observable<any[]> {
    let params = new HttpParams();
    if (filters?.staffId) params = params.set('staffId', String(filters.staffId));
    if (filters?.from) params = params.set('from', filters.from);
    if (filters?.to) params = params.set('to', filters.to);
    return this.http.get<any[]>(`${this.api}/slips`, { ...this.headers, params });
  }

  getDeliveryPricing(): Observable<any> {
    return this.http.get(`${baseUrl}DeliveryPricing`, this.headers);
  }

  getDeliveryPricingHistory(): Observable<any[]> {
    return this.http.get<any[]>(`${baseUrl}DeliveryPricing/history`, this.headers);
  }

  saveDeliveryPricing(payload: { amountPerDelivery: number }): Observable<any> {
    return this.http.put(`${baseUrl}DeliveryPricing`, payload, this.headers);
  }
}
